import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import { useNavigate } from 'react-router-dom';
import Contactimg from '../assets/img/contact.png';
import SeoHelmet from "../components/SeoHelmet";
const Contact = () => {
  const formRef = useRef(); // To reference the form
  const [status, setStatus] = useState(''); // For success or error messages
  const navigate = useNavigate();

  const sendEmail = (e) => {
    e.preventDefault();

    // Use the emailjs library to send the email
    emailjs
    .sendForm(
      "service_hmrezop", // Your EmailJS service ID
      "template_6qlhzgj", // Your EmailJS template ID
      formRef.current, // The form reference
      "1eblwEiXOqFJO88JY" // Your EmailJS user ID
    )
      .then(
        (result) => {
          console.log('SUCCESS!', result.text);
          setStatus('Message sent successfully!'); // Show success message
          formRef.current.reset(); // Reset the form after submission
          // Redirect after success using React Router
          setTimeout(() => {
            navigate('/thank-you'); // This will redirect to the thank you page
          }, 2000); // Delay before redirecting
        },
        (error) => {
          console.error('FAILED...', error.text);
          setStatus('Failed to send message. Please try again.'); // Show error message
        }
      );
  };

  return (
    <>
     <SeoHelmet />
    <section className="contact">
      <div className="container">
        <div className="row">
         
          <div className="col-sm-4">
            <img src={Contactimg} alt="" width="100%" className="contactimg" />
          </div>

          
          <div className="col-sm-8">
            <form ref={formRef} onSubmit={sendEmail} className="contact_form">
              <div className="row">
                
                <div className="col-sm-6">
                  <input
                    type="text"
                    name="fname"
                    className="form-control"
                    placeholder="First Name"
                    required
                  />
                </div>
                
                <div className="col-sm-6">
                  <input
                    type="text"
                    name="lname"
                    className="form-control"
                    placeholder="Last Name"
                    required
                  />
                </div>
               
                <div className="col-sm-6">
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="Email"
                    required
                  />
                </div>
                
                <div className="col-sm-6">
                  <input
                    type="number"
                    name="phone"
                    className="form-control"
                    placeholder="Phone Number"
                    required
                  />
                </div>
                
                <div className="col-sm-12">
                  <div className="inqbtn">
                    <h2>Select Subject?</h2>
                    <div>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="inquiry"
                          value="Online Inquiry"
                        />
                        <label className="form-check-label">Online Inquiry</label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="inquiry"
                          value="Offline Inquiry"
                        />
                        <label className="form-check-label">Offline Inquiry</label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="inquiry"
                          value="General Inquiry"
                        />
                        <label className="form-check-label">General Inquiry</label>
                      </div>
                    </div>
                  </div>
                </div>
               
                <div className="col-sm-12">
                  <label className="messagehe">Message</label>
                  <textarea
                    name="message"
                    className="messagebox"
                    placeholder="Write your message.."
                  ></textarea>
                </div>
              </div>
             
              <button type="submit" className="btn btn-form">
                Send Now
              </button>
            </form>
           
            {status && <p>{status}</p>}
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default Contact;
